import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AuthService } from '../../../core/auth/auth.service';
import { AlertService } from '../../../shared/services/alert.service';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule],
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
  forgotForm: FormGroup;
  isLoading = false;
  errorMessage: string | null = null;
  successMessage: string | null = null;

  private fb = inject(FormBuilder);
  private auth = inject(AuthService);
  private router = inject(Router);
  private alertService = inject(AlertService);

  constructor() {
    this.forgotForm = this.fb.group({
      phoneNumber: ['', [
        Validators.required,
        Validators.pattern(/^(\+994 \((50|51|10|70|77|55|99)\) \d{3}-\d{2}-\d{2}|\+994 (50|51|10|70|77|55) \d{3} \d{2} \d{2})$/)
      ]]
    });
  }

  onPhoneInput(event: any): void {
    const input = event.target;
    let value = input.value;
    const selectionStart = input.selectionStart;
    const oldLength = value.length;

    // Yalnız rəqəmləri saxlayırıq
    let digits = value.replace(/\D/g, '');

    // Əgər +994 ilə başlayırsa, onu çıxarırıq (formatlamada yenidən əlavə olunacaq)
    if (digits.startsWith('994')) {
      digits = digits.substring(3);
    }

    // Maksimum 9 rəqəm (operator + nömrə)
    digits = digits.substring(0, 9);

    let formattedValue = '+994 ';
    if (digits.length > 0) {
      formattedValue += '(' + digits.substring(0, 2);
      if (digits.length > 2) {
        formattedValue += ') ' + digits.substring(2, 5);
        if (digits.length > 5) {
          formattedValue += '-' + digits.substring(5, 7);
          if (digits.length > 7) {
            formattedValue += '-' + digits.substring(7, 9);
          }
        }
      }
    }

    this.forgotForm.get('phoneNumber')?.setValue(formattedValue, { emitEvent: false });

    // Kursorun mövqeyini hesablamaq və bərpa etmək
    setTimeout(() => {
      const newLength = formattedValue.length;
      let newSelection = selectionStart + (newLength - oldLength);

      // Kursorun yanlış yerdə qalmaması üçün tənzimləmə
      input.setSelectionRange(newSelection, newSelection);
    }, 0);
  }

  onSubmit(): void {
    if (this.forgotForm.valid) {
      this.isLoading = true;
      this.errorMessage = null;
      this.successMessage = null;

      let phone = this.forgotForm.get('phoneNumber')?.value as string;
      // Format: +994XXXXXXXXX
      phone = phone.replace(/\s+/g, '').replace(/[()\-]/g, '');

      this.auth.forgotPassword(phone).subscribe({
        next: () => {
          this.isLoading = false;
          this.alertService.success('OTP kod telefonunuza göndərildi.');
          this.router.navigate(['/otp-verification'], { queryParams: { phone: phone, type: 'reset' } });
        },
        error: (err) => {
          this.isLoading = false;
          const errorObj = err.error?.error || err.error;
          const errorCode = errorObj?.code || 'UNKNOWN_ERROR';
          const errorDetails = errorObj?.details;
          this.errorMessage = errorDetails || (errorCode ? this.alertService.getErrorMessage(errorCode) : 'Xəta baş verdi.');
        }
      });
    } else {
      this.forgotForm.markAllAsTouched();
    }
  }
}
